import { Box, Typography } from "@mui/material";

interface EmptyEntityStateProps {
  hasSelectedClient: boolean;
  hasEntities: boolean;
}

const EmptyEntityState = ({
  hasSelectedClient,
  hasEntities,
}: EmptyEntityStateProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        p: 4,
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {hasSelectedClient && !hasEntities
          ? "No entities available for the selected clients"
          : "Select a client to show available entities to clean"}
      </Typography>
    </Box>
  );
};

export default EmptyEntityState;
